import { StyleSheet } from 'react-native';

export const sparklesStyles = StyleSheet.create({
  root: {
    position: 'absolute',
    top: '38%',
    left: '50%',
    width: 0,
    height: 0,
  },
  particle: {
    position: 'absolute',
  },
});
